// Infers "service history complete" from the free-text description when the
// structured attribute is missing (dealer feeds often only mention it in text).

const SERVICE_HISTORY_RE =
  /(carte\s+(de\s+)?service\s+(la\s+zi|complet[ăa]?)|carnet\s+de\s+service\s+la\s+zi|istoric\s+complet\s+de\s+service|toate\s+reviziile\s+(realizate|efectuate|f[ăa]cute)|full\s+service\s+history|service\s+history\s+(complete|full)|scheckheftgepflegt)/i;

export const inferServiceHistoryComplete = (
  structured: boolean | null | undefined,
  description?: string | null,
): boolean | undefined => {
  if (typeof structured === 'boolean') return structured;
  if (description && SERVICE_HISTORY_RE.test(description)) return true;
  return undefined;
};
